import axios from "axios";
import { toast } from "react-toastify";

const customAxios = axios.create({});

let _onExpired = null;
export const setExpiredHandler = (fn) => { _onExpired = fn; };

customAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 402) {
      let message = error.response?.data?.message || error.message || "Your membership has expired.";
      toast.error(message);
      if (_onExpired) _onExpired();
    }
    return Promise.reject(error);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    customAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete customAxios.defaults.headers.common["Authorization"];
  }
};

// Append the current auth token as a query param. Needed for browser-initiated
// downloads (<a> / window.open) that hit authenticated routes but can't send an
// Authorization header.
export const withAuthToken = (url) => {
  const header = customAxios.defaults.headers.common["Authorization"] || "";
  const token = header.replace(/^Bearer\s+/i, "");
  if (!token) return url;
  return url + (url.includes("?") ? "&" : "?") + "token=" + encodeURIComponent(token);
};
export default customAxios;
